import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export const TagItem = ({ tag }: { tag: string }) => (
  <Stack
    data-test="tag-item"
    sx={{
      backgroundColor: 'background.boxDarker',
      borderRadius: '50px',
      px: 1.5,
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Typography
      variant="body1"
      sx={{ fontWeight: '600', fontSize: '12px', color: 'text.secondary', whiteSpace: 'nowrap' }}
    >
      {tag}
    </Typography>
  </Stack>
);
